module.exports = {
  "api-endpoint": "https://api.davoyage.com/website",
  "x-api-key": "g26epGVhQu3Az974lbjYK2mRbvEpY0ba3nd0ojyh",
  "stripe-public-key": "pk_live_xCTaxH21rBVglUHzaSRoB42A",
  "google-reCAPTCHA_site_key": "6LfwT48iAAAAAJ9qzpNKyQo_8RArt4-IuOWGOGz_",
  "google-map-key": "AIzaSyBQisvhH9w6XHXm_-gTccnFaN7SDYm-g5U"
};